import { EligibilityFailMessage, CriteriaOperator } from '../store/features/apply/types';
import { StrOrNum } from '../types/util';
import { createExcerptFromArray } from './text';

export const parseEligibilityValue = (value: EligibilityFailMessage['criteria'][number]['value'] | null): StrOrNum => {
  if (!value) return '---';
  if (Array.isArray(value)) {
    if (value.length === 0) return '---';
    return createExcerptFromArray(value, Infinity, 'and');
  }
  if (typeof value === 'object') {
    return `${value.lowerEnd} and ${value.higherEnd}`;
  }
  return value;
};

export const parseEligibilityOperator = (operator: CriteriaOperator): string => {
  switch (operator) {
    case 'isEqualTo':
      return ':';
    case 'isGreaterThan':
      return 'greater than';
    case 'isGreaterThanOrEqualTo':
      return 'greater than or equal to';
    case 'isInBetween':
      return 'in between';
    case 'isLessThan':
      return 'less than';
    case 'isLessThanOrEqualTo':
      return 'less than or equal to';
    default:
      return operator;
  }
};
